'use strict'

import React from 'react'

export default class FlowForm2 extends React.Component {
  checkDisabled () {
    const { summary, pages, currentPage } = this.props

    let disabled = false

    if (pages[currentPage].required) {
      pages[currentPage].required.forEach((requirement) => {
        if (summary[requirement] === undefined) {
          disabled = true
          return
        }
      })
    }

    return disabled
  }

  componentDidMount () {
    window.fbq('track', 'ViewContent')

    window.ga('send', {
      hitType: 'pageview',
      page: 'Quote form'
    })
  }

  render () {
    const { pages, currentPage, nextPage } = this.props

    const nextButtonDisabled = this.checkDisabled()

    return (
      <form name='dental-quote-form' id='dental-quote-form' className='flow-form2'>
        <div className='flow-form--page'>
          {pages[currentPage].page}
        </div>
        <table className='flow-form--page-indicator'>
          <tbody>
            <tr>
              {pages.map((page, i) => {
                let className = 'flow-form--page-icon'
                if (currentPage > i) className += ' complete'
                if (currentPage === i) className += ' current'
                return (
                  <td key={i}>
                    <span className={className}></span>
                  </td>
                )
              })}
            </tr>
          </tbody>
        </table>
        <div className='align-right padding-1em'>
          {pages[currentPage].showNext && (
            <button className='next-page-button' onClick={nextPage.bind(this)} disabled={nextButtonDisabled}>
              Next
            </button>
           )}
        </div>
      </form>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/assets/flow-form2.js